import { createContext, useState } from 'react';

const ReservationContext = createContext();

export const ReservationProvider = ({ children }) => {
  const [reservation, setReservation] = useState({});

  const data = { reservation, setReservation };

  return (
    <ReservationContext.Provider value={data}>
      {children}
    </ReservationContext.Provider>
  );
};

export default ReservationContext;
